import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ContextService } from '../services/context.service';

/**
 * Factory guard that redirects to /access-denied when the user
 * lacks the given permission code.
 *
 * Usage:
 *   canActivate: [permissionGuard('Users.View')]
 */
export function permissionGuard(requiredPermission: string): CanActivateFn {
  return () => {
    const contextService = inject(ContextService);
    const router = inject(Router);

    const permissions = contextService.getPermissions()?.permissions ?? [];
    if (permissions.includes(requiredPermission)) return true;

    router.navigate(['/access-denied'], { replaceUrl: true });
    return false;
  };
}
